import React, { useEffect, useState } from 'react'
import { IoAddOutline } from 'react-icons/io5'
import TextBox from 'devextreme-react/text-box';
import { toast } from 'react-toastify';

const DiscountCode = () => {
    const [isInputVisible, setIsInputVisible] = useState(false)
    const [discountCode, setDiscountCode] = useState('')
    const [showErrorText, setShowErrorText] = useState(false)

    useEffect(() => {
        if (!isInputVisible) {
            setShowErrorText(false)
        }
    }, [isInputVisible])
    const handleEnterDiscountCode = () => {
        setShowErrorText(true)
    }
    const handleKeyDown = (e) => {
        setShowErrorText(false)
        if (e.event.key === 'Enter') {
            handleEnterDiscountCode()
        }
    }
    const errorTextStyle = showErrorText ? '' : 'collapse'
    return (
        <>
            <div className='row'>
                <div className="col-6">
                    <span>Kod rabatowy</span>
                </div>
                <div className="col-6 text-end">
                    <span onClick={() => setIsInputVisible(prev => !prev)}><IoAddOutline cursor={'pointer'} size={25} /></span>
                </div>
            </div>
            <span className={`error-text-color ${errorTextStyle}`}>Niepoprawny kod rabatowy!</span>
            {isInputVisible &&
                <div className="row mt-3">
                    <div className="col">
                        <TextBox
                            placeholder="Wpisz kod rabatowy"
                            value={discountCode}
                            onValueChanged={(e) => setDiscountCode(e.value)}
                            showClearButton={true}
                            onKeyDown={handleKeyDown}
                        />
                    </div>
                    <div className="col-3">
                        <button type="button" class="btn btn-outline-success" onClick={handleEnterDiscountCode}>Zatwierdź</button>
                    </div>
                </div>
            }
        </>
    )
}

export default DiscountCode